<swb-modal (modalExecute)="modalExecute($event)" #modal="modal">
  <div modal-header>{{ header }}</div>
  <div modal-body>{{ body }}</div>
  <div modal-footer>
    <button class="cta cta--red" (click)="modal.closeModal({submitted: false})">Ne</button>
    <button class="cta cta--green cta--in" (click)="modal.execute()">Ano</button>
  </div>
</swb-modal>